/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tabs, Tab } from '@material-ui/core';

// Utils
import Mixpanel from '../../utils/mixpanel';
import { debounce, formatDateTime } from '../helperFunctions';

// Components
import CustomMenu from '../components/menu';
// import ProductTour from '../components/ProductTour';
import { TaskCard, StoryboardCard } from '../components/cards';
import CreateProjectCard from './CreateProjectCard';
import Icon from '../components/icon';
import DeleteTask from '../storyboard/components/DeleteTask';
import DownloadWithPasscode from '../player/components/DownloadWithPasscode';
import Modal from '../components/modal';
import Loader from '../portal/loader';
import CardLoader from '../components/cardLoader';
import BrowserAlert from '../components/browserAlert';

// Contants
import { MODAL_TYPES, APP_TYPES } from '../constants';
import Carousel from '../components/carousel';
import InfiniteScroll from '../components/infiniteScroll';

// Styles
import { padding, fs, colors } from '../styles/variables';
import { slideDown } from '../styles/animations';
import { CardGrid, GridListParentStyles } from '../styles/common';
import { whiteAlpha } from '../styles/utils';

const FileDownloadButton = styled.button`
  cursor: pointer;
  padding: 0;
  font-size: ${fs.sm};
  margin-bottom: 1.2rem;
  line-height: 1;
  background: none;
  border: none;
  color: ${colors.blue.primary};
  &:hover,
  &:focus {
    text-decoration: underline;
    outline: none;
  }
`;

const TrayRow = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: ${padding.v} 0;
  width: 100%;
  min-height: 28rem;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: ${({ column }) => column && 'column'};
  flex-wrap: ${({ column }) => !column && 'wrap'};
  width: 100%;
  &.grid-box-main {
    display: grid;
    grid-gap: 1.5rem;
    grid-template-columns: repeat(auto-fill, minmax(23.6rem, 1fr));
    .MuiCard-root,
    .grid-wrapper {
      position: relative;
      height: 0;
      padding: 84.74% 0 0 0;
      width: auto;
      min-width: auto;
      margin: 0;
      animation-name: ${slideDown};
      animation-duration: 0.8s;
      .MuiCardContent-root,
      .grid-int-wrapper {
        display: flex;
        position: absolute;
        max-width: 100%;
        max-height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 1.5rem;
      }
      /* &.flip-card-box > div{
        padding: 0px;
      }
      &.loading-box > div{
        padding: 0px;
        width:100%;
        height:100%;
        margin:0;
      } */
    }
    .loading-card {
      width: auto;
    }
  }
`;

const DisplayHelpCard = styled.div`
  width: 28rem;
  height: 22rem;
  background: #0c1d33;
  border-radius: 0.4rem;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  animation-name: ${slideDown};
  animation-duration: 0.5s;
  .header {
    color: #ffffff;
    font-size: 2.2rem;
    font-weight: 100;
    padding: 0;
    line-height: 3rem;
  }
  .bottom-text {
    font-weight: 300;
    font-size: 1.2rem;
    color: #ffffff;
    padding: 0;
    line-height: 2rem;
  }
`;

const CountBadge = styled.span`
  font-size: 1rem;
  margin-left: 1.5rem;
  color: ${colors.white};
  font-weight: 300;
  padding: 0.1rem 1rem;
  border: 0.1rem solid ${whiteAlpha(0.7)};
  border-radius: 1rem;
`;

const TabStyled = styled.div`
  padding: 0 2rem;

  .MuiTabs-root {
    min-height: auto;
  }

  .MuiTab-root {
    min-width: auto !important;
  }

  .task-title {
    font-family: Roboto;
    font-size: 1.4rem;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    padding: 0;
    letter-spacing: normal;
    color: #fff;
    text-transform: capitalize;
  }
  span.MuiTabs-indicator {
    border-radius: 2rem;
    background-color: #2c86ff;
    height: 0.1rem;
  }
  .MuiTabs-flexContainer button {
    border-bottom: 0.1rem solid rgba(44, 134, 255, 0.3);
    padding: 1.2rem 2rem;
    max-width: none;
    min-height: 0;
    &:hover {
      opacity: 1;
    }
  }

  .tab-list {
    border-bottom: 0.1rem solid ${colors.blue.shadeFour};
  }
`;

const ActionContainer = styled.div`
  display: inline-block;
  float: right;
  display: flex;
  align-items: center;
  /* padding-right: 2rem;   //temporary */

  .search-icon,
  .fliter-icon {
    color: ${colors.blue.shadeTwo};
    font-size: 2.3rem;
    cursor: pointer;
  }

  & > div {
    display: flex;
    align-items: center;
  }

  .view-all-box {
    margin-right: 3.5rem;
    a {
      font-size: 1.3rem;
      color: #2c86ff;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .search-box {
    border: 0.1rem solid rgba(44, 134, 255, 0.7);
    border-radius: 2rem;
    padding: 0 1.5rem;
    .search-field-holder {
      .search-field {
        /* transition: all 0.5s ease-out;
				width: 0; */
        border: none;
        color: #fff;
        width: 25rem;
        padding: 1rem;
        background: none;
        font-size: 1.4rem;
        font-weight: 300;
        &:focus {
          outline: none;
        }
        &::placeholder {
          color: #fff;
        }
        .search-icon {
          color: #fff;
          font-size: 2rem;
        }
      }
      .material-icons {
        visibility: hidden;
      }
      #close {
        color: #fff;
        font-size: 2rem;
        position: relative;
        top: 0.5rem;
        right: 0rem;
        cursor: pointer;
        visibility: hidden;
        transition: all 0.3s ease-in-out;
        &:hover {
          color: #ff6c56;
        }
      }
    }
    &.open {
    }
  }
`;

const NOT_AVAILABLE = 'Not Available';

const TAB_FIELDS_TYPES = {
  fields: {
    myTasks: 'my_tasks',
    assignedTasks: 'assigned_tasks',
    sharedAssets: 'shared_assets',
    projects: 'projects',
    collaboratedProjects: 'collaborated_projects',
  },
  type: {
    carousel: 'carousel',
    scroll: 'scroll_load',
  },

  displayType: {
    taskCard: 'task_card',
    projectCard: 'project_card',
  },
};

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index, tabId, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`${tabId}-tabpanel-${index}`}
      aria-labelledby={`${tabId}-tab-${index}`}
      {...other}>
      {value === index && children}
    </div>
  );
}

// const TOUR_OPTIONS = {
//   page: 'homepage',
//   options: [
//     {
//       element: 'task_tabs',
//       title: 'Task Overview',
//       message:
//         'The Tasks assigned to you, assigned by you, and the Assets shared with you are shown here.',
//     },
//     {
//       element: 'project_tabs',
//       title: 'Project Overview',
//       message:
//         'Create your first project, and they’re shown here along with Collaborated Projects & your Team Projects.',
//     },
//     {
//       element: 'team_switch',
//       title: 'Team Switch',
//       align: 'right',
//       message:
//         'Switch between your Personal Team & Other Teams. And access the team-related pages from here.',
//     },
//   ],
// };

class HomeComponent extends Component {
  constructor(props) {
    super(props);
    // this.debounce = null;
    this.state = {
      loader: false,
      isLoading: false,
      isScrollTrayLoading: false,
      loadingAsset: '',
      searchText: '',
      modal: {},
      assetDetails: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedTeam?.team_db_id !== this.props.selectedTeam?.team_db_id
    ) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    const { clearData, pusher } = this.props;
    this.debounce = null;
    clearData();
    if (pusher && this.channel) {
      this.channel.unbind();
      pusher.unsubscribe(this.channel);
    }
  }

  fetchData = () => {
    const { pusher, programStructure, fetchProgramData } = this.props;
    fetchProgramData(programStructure);
    this.createChannels(pusher);
  };

  toggleModal = (type, toggle, title, cb) => {
    let updatedState = {};

    updatedState = {
      modal: {
        title,
        type,
        toggle,
      },
    };

    this.setState({ ...updatedState }, cb && cb());
  };

  renderModals = () => {
    const {
      location,
      selectedTask,
      createUpdateFetchTask,
      toggleToast,
      verifySharedAsset,
    } = this.props;
    const {
      modal: { type },
      assetDetails,
    } = this.state;
    let modal = null;

    switch (type) {
      case MODAL_TYPES.deleteTask:
        modal = (
          <DeleteTask // sidebar component
            createUpdateFetchTask={createUpdateFetchTask}
            toggleModal={this.toggleModal}
            assetDetails={selectedTask.details}
            toggleToast={toggleToast}
          />
        );
        break;

      case MODAL_TYPES.downloadWithPasscode:
        modal = (
          <DownloadWithPasscode
            verifySharedAsset={verifySharedAsset}
            toggleModal={this.toggleModal}
            assetDetails={assetDetails}
            location={location}
          />
        );
        break;
      default: {
        modal = null;
      }
    }
    return modal;
  };

  downloadFile = async (menuItem, item) => {
    const { verifySharedAsset, toggleToast } = this.props;
    const { ingest_db_id, share_token, is_passcode_protected } = item;

    Mixpanel.track('Download - Homepage', { file_type: menuItem.field });
    if (is_passcode_protected) {
      this.setState({ assetDetails: item }, () => {
        this.toggleModal(
          MODAL_TYPES.downloadWithPasscode,
          true,
          'Download Asset'
        );
      });
      return;
    }

    const assetResponse = await verifySharedAsset(
      {
        ingest_db_id,
        shared: share_token,
        download_type: menuItem.field,
      },
      'post'
    );
    const {
      data: { response, data, errormessage },
    } = assetResponse;
    if (response && data) {
      window.open(data.download_link, '_blank');
    } else {
      toggleToast({
        message: {
          messageHead: 'Error',
          messageBody: errormessage,
          variant: 'error',
        },
      });
    }
  };

  onScrollLoad = trayName => {
    const { programData, getPaginatedData } = this.props;
    const currentTray = programData[trayName];
    if (!currentTray) return;
    const { page_no, entries_per_page, total_entries } = currentTray;
    // console.log(page_no, this.state.isLoading, 'on Scroll Load');

    if (currentTray?.data?.length < total_entries) {
      const nextPage = page_no + 1;
      const requestData = {
        form_action: '',
        tray_name: trayName,
        from_date: '',
        to_date: '',
        entries_per_page,
        page_no: nextPage,
        hostname: '',
      };
      this.setState(
        {
          isLoading: true,
          loadingAsset: trayName,
        },
        async () => {
          await getPaginatedData(requestData);
          this.setState({
            isLoading: false,
            loadingAsset: '',
          });
        }
      );
    }
  };

  taskCardProps = (item, field) => {
    const { history, toggleAssignedTaskFromHome } = this.props;
    let customProps = {};
    const baseProps = {
      cardName: item?.title || NOT_AVAILABLE,
      taskType: (item.task_type_label && item.task_type_label) || NOT_AVAILABLE,
      taskStatus: (item.task_status && item.task_status) || NOT_AVAILABLE,
      taskDueDate: item?.expire_at ? formatDateTime(item?.expire_at)?.date : '',
      previewImageLink: item.thumbnail || false,
      iframeURL: (item.iframeurl !== '' && item.iframeurl) || false,
      cardTypeColor:
        item.gradient || 'linear-gradient(to bottom, #7ea2fd, #7967fe)',
      cardType:
        (item.asset_view_type === 'folder' && item.file_type_view) ||
        (item.asset_view_type === 'file' && item.file_type_view),
    };

    if (field === TAB_FIELDS_TYPES.fields.myTasks) {
      customProps = {
        ...baseProps,
        userNames: [item.assigned_by],
        onClick: e => {
          e.stopPropagation();
          if (
            (item.file_type === 'video' ||
              item.file_type === 'image' ||
              item.file_type === 'audio') &&
            item.trans_status === 1 &&
            item.ingest_db_id
          ) {
            Mixpanel.track('My Task', { project: 'Player view' });
            history.push({
              pathname: `/player/${item.ingest_db_id}`,
              search: '',
              state: { file_type: item.file_type },
            });
          } else if (
            item.asset_view_type === 'folder' &&
            item.file_type_view === 'project'
          ) {
            Mixpanel.track('My Task', { project: 'Editor view' });
            history.push(
              `/project/${item.project_db_id}?task=${item.task_db_id}`
            );
          }
        },
      };
    } else if (field === TAB_FIELDS_TYPES.fields.assignedTasks) {
      customProps = {
        ...baseProps,
        userNames: [
          ...item.assigned_to_user_profiles,
          ...item.invited_team_members,
        ],
        timeSpent:
          ((item.task_type !== 'task_approval' ||
            item.task_type !== 'task_review') &&
            item.time_spent) ||
          false,
        topAction: [
          {
            action: 'open-project',
            actionIcon: 'video_library',
          },
        ],
        onClick: e => {
          e.stopPropagation();
          Mixpanel.track('Assigned task');
          if (
            (item.file_type === 'video' ||
              item.file_type === 'image' ||
              item.file_type === 'audio') &&
            item.trans_status === 1 &&
            item.ingest_db_id
          ) {
            history.push({
              pathname: `/player/${item.ingest_db_id}`,
              search: '',
              state: { file_type: item.file_type },
            });
          } else if (
            item.asset_view_type === 'folder' &&
            item.file_type_view === 'project'
          ) {
            toggleAssignedTaskFromHome(item.task_db_id); // assigned task view from home page so open sidebar
            history.push(`/project/${item.project_db_id}`);
          }
        },
      };
    } else if (field === TAB_FIELDS_TYPES.fields.sharedAssets) {
      customProps = {
        ...baseProps,
        taskType: item?.title,
        userNames: [item.extension.toUpperCase()],
        taskDueDate: formatDateTime(item?.expires_on).date,
        renderDropdownMenu: () => {
          // show download button when task_type is not present
          if (
            item?.is_download_allowed &&
            item?.downloads &&
            item?.downloads.length > 1
          ) {
            return (
              <CustomMenu
                icon={
                  <FileDownloadButton type='button'>
                    Download
                  </FileDownloadButton>
                }
                menuList={item.downloads.reduce((acc, curr) => {
                  acc.push({
                    name: `${curr.name} ${curr.file_size || ''}`,
                    field: curr.field,
                  });
                  return acc;
                }, [])}
                onMenuItemClick={menuItem => this.downloadFile(menuItem, item)}
              />
            );
          }
          return (
            item?.is_download_allowed && (
              <FileDownloadButton
                type='button'
                onClick={() => {
                  this.downloadFile(item.downloads && item.downloads[0], item);
                }}>
                Download
              </FileDownloadButton>
            )
          );
        },
        onClick: () => {
          Mixpanel.track('Shared asset', { 'File Type': item.file_type });
          window.open(
            `${process.env.V2_PLAYER_HOSTNAME}/?id=${item.ingest_db_id}&project=${item.project_db_id}&shared=${item.share_token}`,
            '_blank'
          );
          // history.push(
          //   `/player/${item.ingest_db_id}?shared=${item.share_token}`
          // );
        },
      };
    }

    return customProps;
  };

  helpCards = field => {
    // this are nothing but placeholder
    if (field === TAB_FIELDS_TYPES.fields.myTasks) {
      return (
        <>
          <p className='header'>Tasks assigned to you will show up here.</p>
          <p className='bottom-text'>
            Check with your team to get a task for you
          </p>
        </>
      );
    }
    if (field === TAB_FIELDS_TYPES.fields.assignedTasks) {
      return (
        <>
          <p className='header'>Tasks assigned by you will show up here.</p>
          <p className='bottom-text'>
            To assign tasks start with creating a project
          </p>
        </>
      );
    }
    if (field === TAB_FIELDS_TYPES.fields.sharedAssets) {
      return (
        <>
          <p className='header'>Assets shared with you will show up here</p>
          <p className='bottom-text'>
            Share Assets with your team and external agencies.
          </p>
        </>
      );
    }
    if (field === TAB_FIELDS_TYPES.fields.collaboratedProjects) {
      return (
        <>
          <p className='header'>Collaborated projects will show up here</p>
          <p className='bottom-text'>
            Check with your team to get added as a collaborator
          </p>
        </>
      );
    }
    return null;
  };

  // eslint-disable-next-line react/sort-comp
  handleDebounce = debounce((...args) => {
    const { fetchSearchResult } = this.props;
    (async () => {
      await fetchSearchResult(args[0], args[1]);
      this.setState({ isScrollTrayLoading: false });
    })();
  });

  onSearchTextChange = (e, tray) => {
    this.setState({ searchText: e.target.value, isScrollTrayLoading: true });
    this.handleDebounce(e.target.value, tray);
  };

  renderGrids = (tray, tab) => {
    const {
      history,
      createStoryboard,
      toggleUpgradeModal,
      toggleToast,
      userDetails,
    } = this.props;
    const { isLoading, loadingAsset, isScrollTrayLoading } = this.state;
    const details = tray || {}; // extract data
    const { data, field } = details;
    if (tab.type === TAB_FIELDS_TYPES.type.carousel) {
      return (
        <Grid>
          {tray ? (
            <>
              {data && data.length ? (
                <Carousel
                  onChange={(action, totalSlides, currentSlide) => {
                    if (totalSlides === currentSlide && action === 'right') {
                      this.onScrollLoad(field);
                    }
                  }}>
                  {tab.display_type === TAB_FIELDS_TYPES.displayType.taskCard &&
                    data.map(item => {
                      return (
                        <TaskCard
                          field={field}
                          key={
                            item?.task_db_id ||
                            item?.project_db_id ||
                            item?.shared_asset_db_id
                          }
                          {...this.taskCardProps(item, field)}
                        />
                      );
                    })}
                </Carousel>
              ) : (
                <DisplayHelpCard>{this.helpCards(field)}</DisplayHelpCard>
              )}
            </>
          ) : (
            <CardLoader />
          )}
        </Grid>
      );
    }

    if (tab?.type === TAB_FIELDS_TYPES.type.scroll) {
      return (
        <Grid className='grid-box-main'>
          {isScrollTrayLoading ? (
            <CardLoader />
          ) : (
            <>
              {tab.field === TAB_FIELDS_TYPES.fields.projects && (
                <CreateProjectCard
                  createStoryboard={createStoryboard}
                  history={history}
                  toggleUpgradeModal={toggleUpgradeModal}
                  toggleToast={toggleToast}
                  userDetails={userDetails}
                />
              )}
              <InfiniteScroll
                loadAssets={() => this.onScrollLoad(tab.field)}
                isLoading={isLoading}>
                {data?.length > 0 ? (
                  <>
                    {tab?.display_type ===
                      TAB_FIELDS_TYPES.displayType.projectCard &&
                      data?.map(item => {
                        return (
                          <StoryboardCard
                            onClick={() => {
                              Mixpanel.track('Opening Project');
                              history.push({
                                pathname: `/project/${item.project_db_id}`,
                                search: '?tab=project_asset',
                                state: { name: item.title },
                              });
                            }}
                            key={`project-${item.project_db_id}`}
                            cardTitle={item.title}
                            assetNumber={
                              !item.storage_used
                                ? 'Calculating size...'
                                : `${item.storage_used} Used`
                            }
                            cardColor={
                              item.gradient ||
                              'linear-gradient(to bottom, #76a6ff, #3ed5cb)'
                            }
                          />
                        );
                      })}
                  </>
                ) : (
                  <>
                    {tab?.field !== TAB_FIELDS_TYPES.fields.projects && (
                      <DisplayHelpCard>
                        {this.helpCards(tab?.field)}
                      </DisplayHelpCard>
                    )}
                  </>
                )}
                {isLoading &&
                  (loadingAsset === TAB_FIELDS_TYPES.fields.projects ||
                    loadingAsset ===
                      TAB_FIELDS_TYPES.fields.collaboratedProjects) && (
                    <CardLoader />
                  )}
              </InfiniteScroll>
            </>
          )}
        </Grid>
      );
    }

    return null;
  };

  onTabChange = (e, item, newValue) => {
    const { fetchSearchResult, programStructure, loadProgramData } = this.props;
    this.setState(
      () => ({
        ['tab_selected_' + item.field]: newValue,
      }),
      async () => {
        if (item.field === 'project_tabs') {
          this.setState({ isScrollTrayLoading: true, searchText: '' });
          const { field } =
            programStructure[1].values[
              this.state.tab_selected_project_tabs || 0
            ];
          loadProgramData({
            data: { data: [] },
            field,
          });
          await fetchSearchResult('', field);
          this.setState({
            isScrollTrayLoading: false,
          });
        }
      }
    );
  };

  createChannels(pusher) {
    const { userDetails, updatePusherData } = this.props;
    const self = this;
    if (pusher && userDetails) {
      this.channel = pusher.subscribe(`private-${userDetails?.user_id}-home`);
      this.channel.bind('tray_add', responseData => {
        updatePusherData(responseData.data[0], responseData.tray_name, 'add');
      });
      this.channel.bind('tray_update', responseData => {
        updatePusherData(
          responseData.data[0],
          responseData.tray_name,
          'update'
        );
      });
      this.channel.bind('tray_delete', responseData => {
        updatePusherData(
          responseData.data[0],
          responseData.tray_name,
          'delete'
        );
      });
    }
  }

  render() {
    const {
      programStructure,
      programData,
      history,
      requestedCloudSystemDetails,
    } = this.props;
    const { modal } = this.state;

    if (process.env.TYPE !== APP_TYPES.app) {
      return (
        <>
          {!Object.values(programData) ? <Loader /> : null}

          <BrowserAlert isComingSoon={false} />

          <div className='wrapper-body-holder'>
            {programStructure.map(item => {
              let tabUniqueId;
              if (!item.field && !this.state['tab_unique_id_' + item.field]) {
                tabUniqueId = '' + new Date().getTime() + Math.random();
                this.setState({
                  ['tab_unique_id_' + item.field]: tabUniqueId,
                });
              } else {
                tabUniqueId =
                  item.field || this.state['tab_unique_id_' + item.field];
              }

              return (
                <GridListParentStyles>
                  <TabStyled className='tray-tabs'>
                    <ActionContainer className='action-container'>
                      {/* {item.field !== 'storyboard_tabs' && (
                  <div className="view-all-box">
                    <a>View all</a>
                  </div>
                )} */}
                      {item.field === 'project_tabs' && (
                        <div className='search-box'>
                          <Icon className='search-icon' name='search' />
                          <span className='search-field-holder'>
                            <input
                              type='search'
                              className='search-field'
                              value={this.state.searchText}
                              placeholder='Search Project'
                              onChange={e => {
                                e.persist();
                                this.onSearchTextChange(
                                  e,
                                  programStructure[1].values[
                                    this.state.tab_selected_project_tabs || 0
                                  ].field
                                );
                              }}
                            />
                          </span>
                        </div>
                      )}
                      {/* temporarily hide filter */}
                      {/* <div className='fliter-box' style={{ display: 'none' }}>
                    <Icon className='fliter-icon' name='filter_list' />
                  </div> */}
                    </ActionContainer>
                    <Tabs
                      id={item.field}
                      className='tab-list'
                      value={
                        this.state['tab_selected_' + item.field]
                          ? this.state['tab_selected_' + item.field]
                          : 0
                      }
                      onChange={(event, newValue) => {
                        this.onTabChange(event, item, newValue);
                      }}>
                      {item.values.map((tabItem, idx) => {
                        return (
                          <Tab
                            id={tabUniqueId + '-tab-' + idx}
                            className='tab-list-item'
                            aria-controls={tabUniqueId + '-tabpanel-' + idx}
                            label={
                              <h2 className='task-title'>
                                {tabItem.title}{' '}
                                <CountBadge>
                                  {programData[tabItem?.field]?.total_entries ||
                                    0}
                                </CountBadge>
                              </h2>
                            }
                          />
                        );
                      })}
                    </Tabs>
                    {item.values.map((tabItem, idx) => {
                      const trayData = programData[tabItem.field];
                      return (
                        <TabPanel
                          className='tab-panel'
                          tabId={tabUniqueId}
                          value={
                            this.state['tab_selected_' + item.field]
                              ? this.state['tab_selected_' + item.field]
                              : 0
                          }
                          index={idx}>
                          <TrayRow key={`tray-${tabItem.field}`}>
                            <CardGrid style={{ padding: '1rem 0' }}>
                              {this.renderGrids(trayData, tabItem)}
                            </CardGrid>
                          </TrayRow>
                        </TabPanel>
                      );
                    })}
                  </TabStyled>
                </GridListParentStyles>
              );
            })}
          </div>

          <Modal
            onClose={() => this.toggleModal(null, false, null)}
            title={modal.title || null}
            open={modal.toggle || false}>
            {this.renderModals()}
          </Modal>
          {/* <ProductTour
          options={TOUR_OPTIONS.options}
          currentPage={TOUR_OPTIONS.page}
        /> */}
        </>
      );
    }

    if (
      process.env.TYPE === APP_TYPES.app &&
      requestedCloudSystemDetails &&
      Object.keys(requestedCloudSystemDetails).length
    ) {
      history.push({
        pathname: `/project/${requestedCloudSystemDetails?.project_db_id}`,
        ...(requestedCloudSystemDetails?.task_db_id && {
          search: `?task=${requestedCloudSystemDetails?.task_db_id}`,
        }),
      });
      return null;
    }

    return null;
  }
}

HomeComponent.propTypes = {
  createStoryboard: PropTypes.func,
  trays: PropTypes.instanceOf(Array),
  history: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
  match: PropTypes.instanceOf(Object),
  fetchTrays: PropTypes.func,
  fetchSearchResult: PropTypes.func,
  loadSelectedTaskDetails: PropTypes.func,
  createUpdateTask: PropTypes.func,
  toggleSidebar: PropTypes.func,
  requestedCloudSystemDetails: PropTypes.instanceOf(Object),
  programStructure: PropTypes.instanceOf(Object),
  programData: PropTypes.instanceOf(Object),
  pusher: PropTypes.instanceOf(Object),
  fetchProgramStructure: PropTypes.func,
  loadProgramStructure: PropTypes.func,
  fetchProgramData: PropTypes.func,
  loadProgramData: PropTypes.func,
  clearData: PropTypes.func,
  selectedTask: PropTypes.instanceOf(Object),
  createUpdateFetchTask: PropTypes.func,
  toggleUpgradeModal: PropTypes.func,
  toggleToast: PropTypes.func,
  userDetails: PropTypes.instanceOf(Object),
  updatePusherData: PropTypes.func,
  selectedTeam: PropTypes.instanceOf(Object),
  verifySharedAsset: PropTypes.func,
  getPaginatedData: PropTypes.func,
  toggleAssignedTaskFromHome: PropTypes.func,
};

export default HomeComponent;
